export const IMAGE_SOURCE_PROP = 'source';
